import { Box, Grid, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import SectionHeader from '../../../components/shared/SectionHeader';
import TextField from '../../../components/form/TextField';
import SelectField from '../../../components/form/SelectField';
import PhoneField from '../../../components/form/PhoneField';
import NumberField from '../../../components/form/NumberField';
import CurrencyField from '../../../components/form/CurrencyField';
import DatePickerField from '../../../components/form/DatePickerField';
import { US_STATES } from '../../../constants/usStates';

const MARITAL_OPTIONS = [
  { value: 'Married', label: 'Married' },
  { value: 'Separated', label: 'Separated' },
  { value: 'Unmarried', label: 'Unmarried' },
];

const CITIZENSHIP_OPTIONS = [
  { value: 'U.S. Citizen', label: 'U.S. Citizen' },
  { value: 'Permanent Resident', label: 'Permanent Resident Alien' },
  { value: 'Non-Permanent Resident', label: 'Non-Permanent Resident Alien' },
];

const HOUSING_OPTIONS = [
  { value: 'Rent', label: 'Rent' },
  { value: 'Own', label: 'Own' },
  { value: 'Living Rent Free', label: 'Living Rent Free' },
];

const PersonalInfoStep = () => (
  <Box>
    <SectionHeader title="Personal Information" icon={<PersonIcon />} />
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Tell us about yourself
    </Typography>

    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField name="personalInfo.firstName" label="First Name" required size="small" />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField name="personalInfo.middleName" label="Middle Name" size="small" />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField name="personalInfo.lastName" label="Last Name" required size="small" />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField name="personalInfo.email" label="Email Address" type="email" required size="small" />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <PhoneField name="personalInfo.phone" label="Phone Number" required size="small" />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <DatePickerField name="personalInfo.dateOfBirth" label="Date of Birth" />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <SelectField name="personalInfo.maritalStatus" label="Marital Status" options={MARITAL_OPTIONS} size="small" />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <SelectField name="personalInfo.citizenship" label="Citizenship" options={CITIZENSHIP_OPTIONS} size="small" />
      </Grid>
    </Grid>

    <Box sx={{ mt: 3 }}>
      <SectionHeader title="Current Address" icon={<HomeIcon />} />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField name="personalInfo.currentAddress" label="Street Address" required size="small" />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <TextField name="personalInfo.currentCity" label="City" required size="small" />
        </Grid>
        <Grid size={{ xs: 6, sm: 3, md: 4 }}>
          <SelectField name="personalInfo.currentState" label="State" required options={US_STATES} size="small" />
        </Grid>
        <Grid size={{ xs: 6, sm: 3, md: 4 }}>
          <TextField name="personalInfo.currentZip" label="ZIP" required size="small" />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <NumberField name="personalInfo.yearsAtAddress" label="Years at Address" fullWidth size="small" step={0.5} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <SelectField name="personalInfo.housingStatus" label="Housing Status" options={HOUSING_OPTIONS} size="small" />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <CurrencyField name="personalInfo.monthlyRent" label="Monthly Rent/Mortgage" size="small" />
        </Grid>
      </Grid>
    </Box>
  </Box>
);

export default PersonalInfoStep;
